import { createSelector } from 'reselect';

import { RootState } from '../types';
import { backgroundMusicConfigSelector } from './config';

export const mediaSelector = (state: RootState) => state.media;
export const volumeSelector = createSelector(mediaSelector, (media) => media?.volume);
export const gameSoundsSelector = createSelector(mediaSelector, (media) => media?.gameSounds);
export const backgroundMusicSoundSelector = createSelector(mediaSelector, (media) => media?.backgroundMusic);
export const videoStreamSoundSelector = createSelector(mediaSelector, (media) => media?.videoStreamSound);

export const isVideoStreamSoundMutedSelector = createSelector(
  videoStreamSoundSelector,
  (videoStreamSound) => !videoStreamSound
);

export const isGameSoundMutedSelector = createSelector(
  gameSoundsSelector,
  (gameSounds) => !gameSounds
);

export const hasMusicSelector = createSelector(
  backgroundMusicConfigSelector,
  (backgroundMusic) => !!backgroundMusic
);

export const isSoundEnabledSelector = createSelector(
  volumeSelector,
  (volume) => volume?.value > 0 && !volume?.muted
);
